import { createTopic } from '../lib';
import { z } from 'zod';

const marketplaceCatalogSearchedEventSchema = z.object({
  filters: z.record(z.any()),
});

export type MarketplaceCatalogSearchedEvent = z.infer<
  typeof marketplaceCatalogSearchedEventSchema
>;

export const marketplaceCatalogSearchedTopic =
  createTopic<MarketplaceCatalogSearchedEvent>(
    {
      namespace: 'marketplace',
      name: 'catalog-searched',
      description: 'User searched something in the marketplace.',
    },
    marketplaceCatalogSearchedEventSchema,
  );
